module.exports = __webpack_public_path__ + "img/help-ct1.85a22fd2.png";